module.exports = __webpack_public_path__ + "img/电梯动画8.e17c59f6.png";